export default "__VITE_ASSET__DwjYeMxA__"